// @ts-check
/**
 * @file RestoreAccountModal.jsx
 * @location src/components/auth/RestoreAccountModal.jsx
 * @role 30일 grace 안 로그인 시 표시 — 「계정을 복원하시겠습니까?」 + 「로그아웃」.
 *
 *  scope 'member' — 본인 계정 복원
 *  scope 'team'   — 매니저 → 팀 전체 복원
 */
import { useState } from 'react';
import { localizeAuthError } from '../../integrations/supabase/errorMessage.js';

/**
 * @param {{
 *   scope: 'member' | 'team',
 *   onRestore: () => Promise<void>,
 *   onCancel: () => Promise<void> | void,
 * }} props
 */
export function RestoreAccountModal({ scope, onRestore, onCancel }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const restore = async () => {
    if (busy) return;
    setBusy(true); setErr('');
    try { await onRestore(); }
    catch (e) { setErr(localizeAuthError(e, '복원에 실패했습니다. 잠시 후 다시 시도해 주세요.')); }
    finally { setBusy(false); }
  };

  return (
    <div className="auth-screen">
      <div className="modal auth-modal">
        <div className="mhd"><span className="mtit">온점</span></div>
        <div className="mbody">
          <p className="auth-lead">
            계정을 복원하시겠습니까?
          </p>
          <p className="auth-sub">
            {scope === 'team'
              ? '팀 전체가 삭제 예정입니다. 30일 이내라면 복원할 수 있습니다.'
              : '계정이 삭제 예정입니다. 30일 이내라면 복원할 수 있습니다.'}
          </p>
          {err && <div className="auth-err">{err}</div>}
          <div className="restore-actions">
            <button type="button" className="auth-link" onClick={() => onCancel?.()}>
              로그아웃
            </button>
            <button type="button" className="auth-primary btnp" onClick={restore} disabled={busy}>
              {busy ? '복원 중…' : '복원'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
